import * as dat from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

// Shader for PORTAL :
import VertexPortal from './Shader/ShaderPortal/VertexShader.glsl'
import FragmentPortal from './Shader/ShaderPortal/FragmentShader.glsl'

// Shader for FireFlies :
import VertexFireFlies from './Shader/ShaderFire/VertexShader.glsl'
import FragmentFireFlies from './Shader/ShaderFire/FragmentShader.glsl'




/**
 * Base
 */
// Debug
const debugObject = {}
debugObject.clearColor = '#201919'
debugObject.uColorStart = '#201919'
debugObject.uColorEnd = '#A7FCFF'
const gui = new dat.GUI({
    width: 400
})

gui.addColor(debugObject, 'clearColor').onChange(() => 
{
    renderer.setClearColor(debugObject.clearColor)
}).name("Background Color")


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Object
 */

const bakedTexture = textureLoader.load('BakedFinal.jpg')
bakedTexture.flipY = false
bakedTexture.encoding = THREE.sRGBEncoding


const bakedmaterial = new THREE.MeshBasicMaterial ({ map : bakedTexture })

const poleLight = new THREE.MeshBasicMaterial({ color: "#ffa853" })


const Portal = new THREE.ShaderMaterial({
    vertexShader : VertexPortal,
    fragmentShader : FragmentPortal,
    uniforms:
    {
        uTime : { value : 0 },
        uColorStart : { value : new THREE.Color(debugObject.uColorStart)},
        uColorEnd : { value : new THREE.Color(debugObject.uColorEnd)}
    }
})


gltfLoader.load(
    'PORTAL.glb',
    (gltf) => 
    {
        const World = gltf.scene.children.find(child => child.name === 'Plane002')
        const PolelightA = gltf.scene.children.find(child => child.name === 'Cube006')
        const PolelightB = gltf.scene.children.find(child => child.name === 'Cube010')
        const PortalA = gltf.scene.children.find(child => child.name === 'Circle')

        PolelightA.material = poleLight
        PolelightB.material = poleLight
        PortalA.material = Portal
        World.material = bakedmaterial

        scene.add(gltf.scene)
    }
)






const Fireflies = new THREE.BufferGeometry()
const FireNumber = 30
const position = new Float32Array(FireNumber * 3)
const aScale = new Float32Array(FireNumber * 1)

for(let i = 0; i < FireNumber; i++)
{
    position[i*3 + 0] = (Math.random()-0.5) * 4
    position[i*3 + 1] = Math.random() * 1.5
    position[i*3 + 2] = (Math.random()-0.5) * 4

    aScale[i] = Math.random()
}

Fireflies.setAttribute('position', new THREE.BufferAttribute(position, 3))
Fireflies.setAttribute('aScale', new THREE.BufferAttribute(aScale, 1))

const fireflieMaterial = new THREE.ShaderMaterial(
    {
        uniforms: 
        {
            uDevice : { value : Math.min(window.devicePixelRatio, 2) },
            uSize : { value : 200 },
            uTime : { value : 0 }
        },
        vertexShader : VertexFireFlies,
        fragmentShader : FragmentFireFlies,
        transparent: true,
        blending: THREE.AdditiveBlending,
        depthWrite: false
    }
)

const FinalFire = new THREE.Points(Fireflies, fireflieMaterial)
scene.add(FinalFire)

console.log(position)

gui.add(fireflieMaterial.uniforms.uSize, 'value').min(0).max(500).step(1).name('Size of Fireflies')

gui.addColor(debugObject, 'uColorStart').onChange(() => 
{
    Portal.uniforms.uColorStart.value.set(debugObject.uColorStart)
}).name("Color portal START")

gui.addColor(debugObject, 'uColorEnd').onChange(() => 
{
    Portal.uniforms.uColorEnd.value.set(debugObject.uColorEnd)
}).name("Color portal END")



















/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    fireflieMaterial.uniforms.uDevice.value = Math.min(window.devicePixelRatio, 2)
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 2
camera.position.z = 4
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setClearColor(debugObject.clearColor)

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    fireflieMaterial.uniforms.uTime.value = elapsedTime
    Portal.uniforms.uTime.value = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()